module.exports = {"id":"212107","name":"Adis Jahović","rating":"74","photo":"./data/images/photos/0/212107.png","club":{"name":"Konyaspor","logo":"./data/images/clubs/Konyaspor.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdisJahovic0.json
// module id = 100
// module chunks = 0